/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Icon } from '@chakra-ui/react';
import { CustomIconProps } from './CustomIcon.types';
import * as S from './CustomIcons.styles';

export function CustomIcon({
  icon,
  color,
  $bgColor,
  $borderColor,
  padding,
  boxSize,
  width,
  height,
  $isRounded,
  ...rest
}: CustomIconProps) {
  return (
    <S.Container
      width={width}
      height={height}
      $bgColor={$bgColor}
      $borderColor={$borderColor}
      $isRounded={$isRounded}
      {...rest}
    >
      <Icon as={icon} boxSize={boxSize} color={color} padding={padding} />
    </S.Container>
  );
}
